import React, { useRef } from "react";
import { FileText, Trash2, Plus, ExternalLink } from "lucide-react";

export const FileButton = ({
  title,
  onUploadFile,
  url,
  onDelete,
  isFileSelected,
  fileName,
  errorText,
}) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onUploadFile(file);
    }
    e.target.value = "";
  };

  const handleOpenLink = () => {
    if (url && typeof url === "string" && url.startsWith("http")) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="w-full">
      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.doc,.docx,application/pdf"
        onChange={handleFileChange}
        className="hidden"
      />

      {isFileSelected ? (
        <div className="space-y-1">
          <div className="flex items-center justify-between p-3.5 bg-white border border-gray-200 rounded-xl shadow-xs">
            <button
              type="button"
              onClick={handleOpenLink}
              disabled={!url || typeof url !== "string" || !url.startsWith("http")}
              className="flex items-center gap-2.5 min-w-0 flex-1 text-left group"
            >
              <div className="w-9 h-9 rounded-lg bg-red-50 text-red-500 flex items-center justify-center flex-shrink-0">
                <FileText className="w-5 h-5" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-gray-900 truncate group-hover:text-[#020637] transition-colors">
                  {fileName || "Technical Document"}
                </p>
                {url && typeof url === "string" && url.startsWith("http") && (
                  <p className="text-[11px] text-gray-400 flex items-center gap-1">
                    Click to view <ExternalLink className="w-3 h-3" />
                  </p>
                )}
              </div>
            </button>

            <button
              type="button"
              onClick={onDelete}
              className="w-9 h-9 rounded-lg flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors ml-2"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
          {errorText && (
            <p className="text-xs text-red-500 font-medium pl-1">{errorText}</p>
          )}
        </div>
      ) : (
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-xl border border-dashed border-gray-300 hover:border-[#020637] hover:bg-[#eef0f8]/30 text-gray-700 hover:text-[#020637] text-sm font-semibold transition-all bg-white"
        >
          <Plus className="w-4 h-4 stroke-[2.5]" />
          <span>{title}</span>
        </button>
      )}
    </div>
  );
};
